import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('EmailBanner')
export class EmailBanner {

    @JsonProperty('bannerName')
    bannerName = '';

    @JsonProperty('position')
    position = 'Top';

    @JsonProperty('lang',String,true)
    lang = '';

    @JsonProperty('uid',String,true)
    uid = '';

    @JsonProperty('size',Number,true)
    size = 0;

    @JsonProperty('order_id',Number,true)
    order_id = 0;

    constructor() {
      /*this.bannerName = json.bannerName;
      this.position = json.position;
      this.order_id = json.order_id;
      this.size = json.size;
      this.lang = json.lang;*/
    }

}
